import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { get_vendor_list } from "../../redux/vendorSlice";
import { useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const VendorList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [searchTerm, setSearchTerm] = useState(""); // ✅ search term state

  const { vendor_list, total_vendor_count, loading } = useSelector(
    (state) => state.vendors
  );

  useEffect(() => {
    store.dispatch(get_vendor_list({ page, rows }));
  }, [page, rows]);

  // ✅ Filter vendor list locally based on name
  const filteredVendors = vendor_list.filter((vendor) =>
    vendor.tradename?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const onPrevious = () => {
    if (page > 1) {
      setInitialValue((prev) => prev - Number(rows));
      setPage((prev) => prev - 1);
      store.dispatch(get_vendor_list({ page: page - 1, rows }));
    }
  };

  const onNext = () => {
    if (rows * page < total_vendor_count) {
      setInitialValue((prev) => prev + Number(rows));
      setPage((prev) => prev + 1);
      store.dispatch(get_vendor_list({ page: page + 1, rows }));
    }
  };

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>
          Vendors List
        </Heading>

        <Spacer display={["none", "none", "block"]} />

        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap"
        >

          <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
            <Input
              placeholder="Search by vendor name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)} // ✅ update state
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>
      {loading ? (<GasCylinderLoader
        size="sm"
        loadingText="Loading Vendors"
      />) : (<>
        <SimpleGrid minChildWidth="xs" spacing="10px">
          {filteredVendors.length > 0 ? (
            filteredVendors.map((el, i) => (
              <Card
                key={i}
                paddingInline={5}
                paddingBlock={2}
                cursor="pointer"
                onClick={() => navigate("/vendors-list/vendor-detail", { state: el.id })}
              >
                <DisplayData
                  fs="16px"
                  v_color="#169e49"
                  fw="bold"
                  value={el.tradename || "NA"}
                />
                <Flex justify="space-between">
                  <DisplayData title="GST" value={el.gst || "NA"} />
                </Flex>
                <DisplayData title="Personal Mobile" value={el.mobile_personal || "NA"} />
                <DisplayData title="State" value={el.state || "NA"} />
              </Card>
            ))
          ) : (
            <Card p={5} textAlign="center">
              <Text color="gray.500">No vendors found</Text>
            </Card>
          )}
        </SimpleGrid>

        <Card alignItems="center" alignSelf="end" gap={3} flexDirection="row">
          <Flex
            w="full"
            h="auto"
            justify={{ base: "center", md: "flex-end" }}
            alignItems="center"
            flexWrap="wrap"
            px={{ base: 4, md: 10 }}
            py={4}
            gap={4}
          >
            <Text fontSize="sm">Rows per page:</Text>
            <Select
              size="sm"
              maxW="70px"
              value={rows}
              onChange={(e) => {
                const value = e.target.value;
                setRows(value);
                store.dispatch(get_vendor_list({ page, rows: value }));
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>

            <Flex gap={1} align="center" fontSize="sm">
              <Text>{initialValue}</Text>
              <Text>-</Text>
              <Text>{rows * page >= total_vendor_count ? total_vendor_count : rows * page}</Text>
              <Text>of</Text>
              <Text>{total_vendor_count}</Text>
            </Flex>

            <FiChevronLeft
              cursor="pointer"
              color={page === 1 ? "gray" : "#007bc9"}
              size={25}
              onClick={onPrevious}
            />

            <FiChevronRight
              cursor="pointer"
              color={rows * page >= total_vendor_count ? "gray" : "#007bc9"}
              size={25}
              onClick={onNext}
            />
          </Flex>
        </Card>
      </>)}

    </>
  );
};

export default VendorList;
